import React, { cloneElement } from 'react';
import { Shield, Heart, Stethoscope, Activity, Wallet, Users } from 'lucide-react';
export function WhyChoose() {
  const features = [{
    icon: <Stethoscope className="w-8 h-8 text-brand-gold" data-id="element-249" data-mp="3syk1gtc0vk2n" />,
    title: 'Experienced Medical Team',
    desc: 'Our doctors and nurses bring years of expertise and compassionate care to every patient visit.'
  }, {
    icon: <Heart className="w-8 h-8 text-brand-gold" data-id="element-250" data-mp="3j8h4ki1s5lz1" />,
    title: 'Comprehensive Healthcare',
    desc: "From general consultations to specialized diagnostics, we cover all your family's health needs."
  }, {
    icon: <Activity className="w-8 h-8 text-brand-gold" data-id="element-251" data-mp="39c5mfbfie1wo" />,
    title: 'Modern Equipment',
    desc: 'Equipped with advanced diagnostic tools including ultrasound, ECG, and a full laboratory.'
  }, {
    icon: <Shield className="w-8 h-8 text-brand-gold" data-id="element-252" data-mp="30ao89ylnwaam" />,
    title: 'Fast Diagnosis',
    desc: 'Quick turnaround times on lab results and imaging to get you on the path to recovery sooner.'
  }, {
    icon: <Wallet className="w-8 h-8 text-brand-gold" data-id="element-253" data-mp="3pbc7wa4bf5mm" />,
    title: 'Affordable Care',
    desc: 'Premium healthcare services priced transparently and affordably for the community.'
  }, {
    icon: <Users className="w-8 h-8 text-brand-gold" data-id="element-254" data-mp="2zote7ar0p78" />,
    title: 'Community Focused',
    desc: 'Deeply rooted in Tsabong, we are dedicated to improving the health of our local community.'
  }];
  return <section className="py-20 bg-brand-light" data-id="element-255" data-mp="31jopyhp174wh">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256" data-mp="31kzreav080kf">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-257" data-mp="3g8b62lmhg0or">
          <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-258" data-mp="3gant3d73l18o">
            Why Choose Maisha
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-6" data-id="element-259" data-mp="2nri9svlvoxx1">
            Your Health Is Our Devotion
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed" data-id="element-260" data-mp="2ir2xm7dc1wgn">
            We provide high-quality, compassionate, and affordable healthcare
            services to individuals and families in Tsabong and throughout
            Botswana.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-261" data-mp="wh5985xhqk3j">
          {features.map((feature, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-soft hover:shadow-soft-lg transition-all duration-300 border border-slate-50 group hover:-translate-y-1" data-id="element-262" data-mp="10gnrsv1uaj37" data-mpi={idx}>
              <div className="w-16 h-16 bg-brand-lighter rounded-2xl flex items-center justify-center mb-6 group-hover:bg-brand-navy transition-colors" data-id="element-263" data-mp="8s45ux3ilz54">
                {cloneElement(feature.icon as React.ReactElement, {
              className: 'w-8 h-8 text-brand-gold group-hover:text-white transition-colors'
            })}
              </div>
              <h3 className="text-xl font-heading font-bold text-brand-navy mb-3" data-id="element-264" data-mp="1t49y4b2gc1tr">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-265" data-mp="1yb8bnwwf61yj">{feature.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}